import React from 'react';

const SectionHeading = ({ title, className, subtext, 'data-testid': dataTestId }) => {
    return (
        <div>
            <div className={`section-heading ${className}`} data-testid={dataTestId}>{title}</div>
            {subtext && (
                <div className={`section-subtext`} data-testid={dataTestId && `${dataTestId}.subtext`}>{subtext}</div>
            )}
        </div>
    );
    // return <div className={`section-heading ${className}`}>{title}</div>;
};

export default SectionHeading;
